import useUser from "../user/useUser";
import { useEffect } from "react";
import { isBlogSaved } from "../../api/listings";
import { useBlogCardWebContext } from "../../components/blog/blogCard";
import { Listing } from "../../interfaces/training-plan/Listing";

type useIsBlogSaved = {
  blog: Listing;
};

export const useIsBlogSaved = ({ blog }: useIsBlogSaved) => {
  const { user } = useUser();
  const { dispatch } = useBlogCardWebContext();

  useEffect(() => {
    const verifyBlogSaved = async () => {
      const isSaved = await isBlogSaved(blog.id, user.token);
      dispatch({ isSaved: isSaved });
    };

    void verifyBlogSaved();
  }, [blog.id, dispatch, user?.token]);
};
